
import { MaterialModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { scrapCausesStore as materialsStore } from '@/libs/material/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import MaterialDialog from '../components/MaterialDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        MaterialDialog,
    },
})
export default class Materials extends Page {
    get headers() {
        return [
            { text: this.$i18n.t('materials.code'), value: 'code', align: 'left', sortable: false },
            { text: this.$i18n.t('materials.name'), value: 'name', align: 'left', sortable: false },
            { text: this.$i18n.t('materials.costs'), value: 'costs', align: 'left', sortable: false },
            { text: this.$i18n.t('materials.unitOfMeasure'), value: 'unitOfMeasure.shortCode', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: MaterialDialog;

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return materialsStore.useGetter(CrudGetter.Pending);
    }

    get items(): MaterialModel[] {
        return [...materialsStore.useGetter(CrudGetter.Data)];
    }

    get totalRows(): number {
        return ({ ...materialsStore.useGetter(CrudGetter.DataStats) } as CrudDataStats)?.rowCount;
    }

    mounted() {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load() {
        materialsStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<MaterialModel>(
            [
                { field: 'code', index: 1, order: 'asc' },
                { field: 'name', index: 2, order: 'asc' },
            ],
            this.getFilters()
        );
    }

    open(item: MaterialModel) {
        this.dialog.open(item.id!);
    }

    createItemClick() {
        this.dialog.open(Guid.EmptyGuid());
    }
}
